import React, { useContext, useEffect } from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { NavbarContext } from './NavbarContext.js';
import NavbarHelpDropdownMenu from './NavbarHelpDropdownMenu.js';
import { getTargetSimple } from './NavbarHelpers.js';

var NavbarHelpLink = function NavbarHelpLink(_ref) {
  var url = _ref.url,
      _ref$dataLwtId = _ref.dataLwtId,
      dataLwtId = _ref$dataLwtId === void 0 ? 'navbar-help-link' : _ref$dataLwtId,
      className = _ref.className,
      linkWrapper = _ref.linkWrapper,
      menuItems = _ref.menuItems,
      menuItemsLinkWrapper = _ref.menuItemsLinkWrapper,
      location = _ref.location,
      target = _ref.target,
      _ref$hideHelpHeader = _ref.hideHelpHeader,
      hideHelpHeader = _ref$hideHelpHeader === void 0 ? false : _ref$hideHelpHeader,
      dropdownMenuMaxWidth = _ref.dropdownMenuMaxWidth;

  var _useContext = useContext(NavbarContext),
      setHelpUrl = _useContext.setHelpUrl,
      setHelpMenuLocation = _useContext.setHelpMenuLocation,
      setHelpItemLinkWrapper = _useContext.setHelpItemLinkWrapper,
      setHelpDropdownItemLinkWrapper = _useContext.setHelpDropdownItemLinkWrapper,
      setHelpMenuItems = _useContext.setHelpMenuItems,
      setHelpTarget = _useContext.setHelpTarget,
      setHideHelpMenuHeader = _useContext.setHideHelpMenuHeader;

  useEffect(function () {
    if (url) {
      setHelpUrl(url);
    }
  }, [url]);
  useEffect(function () {
    if (linkWrapper) {
      setHelpItemLinkWrapper(function () {
        return linkWrapper;
      });
    }
  }, [linkWrapper]);
  useEffect(function () {
    if (menuItems) {
      setHelpMenuItems(menuItems);
    }
  }, [menuItems]);
  useEffect(function () {
    if (menuItemsLinkWrapper) {
      setHelpDropdownItemLinkWrapper(function () {
        return menuItemsLinkWrapper;
      });
    }
  }, [menuItemsLinkWrapper]);
  useEffect(function () {
    if (location && location.pathname) {
      setHelpMenuLocation(location.pathname);
    }

    if (target) {
      setHelpTarget(target);
    }
  }, [location, target]);
  useEffect(function () {
    setHideHelpMenuHeader(hideHelpHeader);
  }, [hideHelpHeader]);

  if (menuItems) {
    return React.createElement(NavbarHelpDropdownMenu, {
      location: location,
      menuItems: menuItems,
      dataLwtId: dataLwtId,
      linkWrapper: menuItemsLinkWrapper,
      hideHelpHeader: hideHelpHeader,
      maxWidth: dropdownMenuMaxWidth
    });
  }

  return React.createElement(React.Fragment, null, url && React.createElement("div", {
    className: "helix-unified-nav__additional-nav-item helix-unified-nav__additional-help-link ".concat(className ? className : ''),
    "data-lwt-id": dataLwtId
  }, React.createElement(React.Fragment, null, linkWrapper ? React.cloneElement(linkWrapper({
    url: url,
    props: {
      className: 'helix-unified-nav__nav-button-link'
    },
    label: React.createElement(NavbarHelixIcon, {
      iconName: 'question_help'
    })
  }), {
    className: 'helix-unified-nav__nav-button-link',
    'aria-label': 'Help'
  }) : React.createElement("a", Object.assign({
    href: url,
    className: 'helix-unified-nav__nav-button-link'
  }, getTargetSimple(target), {
    "aria-label": 'Help'
  }), React.createElement(NavbarHelixIcon, {
    iconName: 'question_help'
  })))));
};

export { NavbarHelpLink as default };